import React from 'react';
import { SectionFolder } from '@src/components/SectionFolder';
import { SectionTitle } from '@src/components/SectionTitle';
import { SectionProps } from '../types/Settings';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { SECTION_TITLE_SIZE } from '../utils/variables';
import { SectionContent } from '../subcomponents/SectionContent';
import { createChangeSettings } from '../utils/createChangeSettings';
import { SettingsCheckbox } from '../subcomponents/SettingsCheckbox';
import { AttributionIcon } from '../../Icons/DropDownIcons/Attribution';
import Tooltip from '@mui/material/Tooltip';
import { InfoSvgIcon } from '@src/components/SvgIcons/Info';
import { style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';

const Attribution = ({ opened, onOpen, editedWidget, setEditedWidget }: SectionProps) => {
  const changeSettings = createChangeSettings(editedWidget, setEditedWidget);

  return (
    <SectionFolder
      title={
        <SectionTitle size={SECTION_TITLE_SIZE}>
          <AttributionIcon />
          {lang.title.main}
        </SectionTitle>
      }
      opened={opened}
      afterTitle={
        <Tooltip title={lang.tooltips.attribution} placement="top">
          <span className={infoAttributionClass}>
            <InfoSvgIcon />
          </span>
        </Tooltip>
      }
      onOpen={onOpen}
    >
      <SectionContent>
        <Tooltip title={lang.tooltip.attribution} placement="bottom">
          <div>
            <SettingsCheckbox
              label={lang.fields.attribution}
              checked={editedWidget.settings.show_attribution}
              onClick={() =>
                changeSettings({
                  show_attribution: !editedWidget.settings.show_attribution,
                })
              }
            />
          </div>
        </Tooltip>
      </SectionContent>
    </SectionFolder>
  );
};

const lang = LocalizedStrings({
  en: {
    title: {
      main: 'Attribution',
    },
    fields: { 
      attribution: 'Show AdAlong attribution',
    },
    tooltips: {
      attribution: 'Control whether to display AdAlong branding and attribution on your widget',
    },
    tooltip: {
      attribution: '*Uncheck to remove the AdAlong watermark on Thumbnails and a "Powered by AdAlong" label in the Shop This Look section.',
    },
  },
});

const infoAttributionClass = style({
  marginLeft: 10,
  color: ADALONG_COLORS.LIGHT_GRAY,
});

export default Attribution;
